import React from "react";

import nth0 from "@/modules/nth0";
import { assetImg } from "@/modules/moduleImporter";
import { getSamGongText } from "@/modules/games/SamGong";

import "./index.scss";
import { IVirtualBalls } from "@/types/GlobalTypes";

export default class SamGongVirtualBalls extends React.Component<IVirtualBalls> {
	render() {
		if (!this.props.lottoResult) 
			return null;

		const {
			activeGame,
			betClosed,
			enableRotation,
			langdata,
			lottoResult
		} = this.props;

		const pcode = activeGame.pcode;
		
		const leftBallSplit = lottoResult.ballLeft.split(",");
		const rightBallSplit = lottoResult.ballRight.split(",");

		const cardComponentFunction = (card: string, idx: number) => (
			card !== "x" ? [
				<div key={"lvb_" + idx + "_0"}>
					{ nth0(2 - idx) }
				</div>,

				// The scan result
				assetImg("m32", card + ".gif", "lvb_" + idx + "_1")
			] : [
				<div key={"lvb_" + idx + "_0"} />,
				<div key={"lvb_" + idx + "_1"} />
			]
		);


		//Calculates player & banker ball value
		const playerOutput = getSamGongText(lottoResult.ballLeft);
		const bankerOutput = getSamGongText(lottoResult.ballRight);

		return (
			<div className={"samgong-virtual-balls" +
				(this.props.showHugeStreaming ? " hugestreaming" : "") +
				(!enableRotation && betClosed ? " bet-closed" : "") +
				(" " + pcode)
			}>
				<div className="player">
					<div>
						{langdata["txt_player"]}
					</div>

					<div className="value">
						{ playerOutput }
					</div>
				{
					leftBallSplit.map((card, idx) => (
						<div key={"lvb_" + idx}>
							{ cardComponentFunction(card, idx) }
						</div>
					))
				}
				</div>

				<div className="banker">
					<div>
					{langdata["txt_banker"]}
					</div>
					<div className="value">
						{ bankerOutput }
					</div>
				{
					rightBallSplit.map((card, idx) => (
						<div key={"lvb_" + idx}>
							{ cardComponentFunction(card, idx) }
						</div>
					))
				}
				</div>
			</div>
		);
	}

}